// eslint-disable-next-line no-unused-vars
import React, { FC, SVGProps } from 'react';

export const Edit: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1202_199439)">
        <path
          d="M15.4136 1.78125L14.2261 0.59375C13.8511 0.21875 13.3199 0 12.8199 0C12.3199 0 11.7886 0.21875 11.4136 0.59375L9.06986 2.9375L8.00736 4L0.38236 11.625L0.00736049 15.1875C-0.0551395 15.625 0.28861 16 0.72611 16C0.75736 16 0.78861 16 0.81986 16L4.38236 15.625L12.0074 8L13.0699 6.9375L15.4136 4.59375C16.1949 3.8125 16.1949 2.5625 15.4136 1.78125ZM3.69486 14.1875L1.60111 14.4063L1.81986 12.3125L9.03861 5.0625L10.0074 4.09375L11.9136 6L10.9449 6.96875L3.69486 14.1875ZM14.3511 3.53125L12.9761 4.9375L11.0699 3.03125L12.4761 1.65625C12.6011 1.53125 12.7574 1.5 12.8199 1.5C12.8824 1.5 13.0386 1.53125 13.1636 1.65625L14.3511 2.84375C14.5386 3.03125 14.5386 3.34375 14.3511 3.53125Z"
          fill="#5B2F91"
        />
      </g>
      <defs>
        <clipPath id="clip0_1202_199439">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
